module.exports = __webpack_public_path__ + "img/code-wechat.2d686ff8.png";